import type { ColGroupDef } from 'ag-grid-community'

import AnalyticsKpisBuilder from '../AnalyticsKpisBuilder'
import { formatMoney } from '../utils'

export const mwmEltvDefs: ColGroupDef = {
  children: [
    {
      aggFunc: 'mwmEltvd30Avg',
      field: 'mwm_total_pred_d30_360_eur',
      headerName: 'D30',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'mwmEltvd10Avg',
      field: 'mwm_total_pred_d10_360_eur',
      headerName: 'D10',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'mwmEltvd7Avg',
      field: 'mwm_total_pred_d7_360_eur',
      headerName: 'D7',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'mwmEltvd3Avg',
      field: 'mwm_total_pred_d3_360_eur',
      headerName: 'D3',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'mwmEltvd0Avg',
      field: 'mwm_total_pred_d0_360_eur',
      headerName: 'D0',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
  ],
  headerClass: 'lightGreyFill',
  headerName: 'MWM eLTV',
}
